import { render } from "./SearchWImage.vue?vue&type=template&id=66dbf16d&scoped=true&ts=true"
import script from "./SearchWImage.vue?vue&type=script&lang=ts"
export * from "./SearchWImage.vue?vue&type=script&lang=ts"

import "./SearchWImage.vue?vue&type=style&index=0&id=66dbf16d&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dbf16d"]])

export default __exports__